var _path, _circle, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 314,
    viewBox: "0 0 316 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 18C316 8.05888 307.941 0 298 0H143C133.059 0 125 8.05888 125 18V44.8039C125 55.8496 133.954 64.8039 145 64.8039H156.395C173.85 64.8039 188 78.9539 188 96.4089C188 106.676 196.324 115 206.591 115H298C307.941 115 316 106.941 316 97V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 97,
    r: 25,
    fill: "#151521"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_15419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.855 97C169.855 100.94 168.29 104.719 165.503 107.506C162.717 110.292 158.938 111.857 154.998 111.857C151.057 111.857 147.278 110.292 144.492 107.506C141.706 104.719 140.141 100.94 140.141 97M169.855 97C169.855 93.0596 168.29 89.2806 165.503 86.4944C162.717 83.7081 158.938 82.1428 154.998 82.1428C151.057 82.1428 147.278 83.7081 144.492 86.4944C141.706 89.2806 140.141 93.0596 140.141 97M169.855 97H140.141",
    stroke: "#2DCA8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71 97C160.429 102.433 158.428 107.636 154.996 111.857C151.563 107.636 149.562 102.433 149.281 97C149.562 91.5668 151.563 86.3637 154.996 82.1428C158.428 86.3637 160.429 91.5668 160.71 97Z",
    stroke: "#2DCA8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 97.5862C120.5 88.4259 113.074 81 103.914 81H20C9.50659 81 1 89.5066 1 100V294C1 304.493 9.50659 313 20 313H296C306.493 313 315 304.493 315 294V151C315 140.507 306.493 132 296 132H154.914C135.908 132 120.5 116.592 120.5 97.5862Z",
    stroke: "#2DCA8F",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_15419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(139 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinWeb);
export default __webpack_public_path__ + "static/media/min-web.c9a9f52a00b83b7ebf62bbb71b34f1d5.svg";
export { ForwardRef as ReactComponent };